import { useState, useEffect } from "react";
import AddNewPitanje from "../Pitanje/AddNewPitanje";
import { Form, Input, Button, DatePicker, Select, Modal } from "antd";
import dayjs from "dayjs";
import AnketaService from "../../services/anketa.service";
import PitanjeService from "../../services/pitanje.service";
import PonudjeniOdgovorService from "../../services/ponudjeniOdgovor.service";
import SaglasnostService from "../../services/saglasnost.service";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../Anketa/AddNewAnketa.css";
import Pitanje from "../Pitanje/Pitanje";
import { useNavigate, useParams } from "react-router-dom";
import UpdatePitanje from "../Pitanje/UpdatePitanje";
import EditPitanjeBeforeSave from "../Pitanje/EditPitanjeBeforeSave";
import Background from "../../components/Background4.jsx";
import { useAuth } from "../../components/AuthContext";
import NotFound from "../../components/NotFound"; 
const { TextArea } = Input;

const EditAnketaPage = () => {
  const [naziv, setNaziv] = useState("");
  const [opis, setOpis] = useState("");
  const [statusAnkete, setStatus] = useState("AKTIVNA");
  const [datumVazenja, setDatumVazenja] = useState(null);
  const [datumKreiranja, setDatumKreiranja] = useState(null);
  const [korisnikKorisnickoIme, setKorisnikKorisnickoIme] = useState("");
  const [token, setToken] = useState("");
  const [tip, setTip] = useState("JAVNA");
  const [pitanja, setPitanja] = useState([]);
  const [counter, setCounter] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [saglasnosti, setSaglasnosti] = useState([]);
  const [saglasnost, setSaglasnost] = useState(1);
  const [confirmIndex, setConfirmIndex] = useState(null);
  const [dateConfirmVisible, setDateConfirmVisible] = useState(false);
  const [newDatumVazenja, setNewDatumVazenja] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editPitanjaIds, setEditPitanjaIds] = useState([]);
  const { username } = useAuth();
  const [notFound, setNotFound] = useState(false);

  const handleEditClick = (id) => {
    setEditPitanjaIds((prevState) => {
      if (prevState.includes(id)) {
        return prevState.filter((editingId) => editingId !== id);
      } else {
        return [...prevState, id];
      }
    });
  };

  useEffect(() => {
    const fetchSaglasnosti = async () => {
      try {
        const response = await SaglasnostService.getAll();
        setSaglasnosti(response.data);
      } catch (error)  {
         if (error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("Greška pri učitavanju ankete:", error);
        }
      }
    };

    fetchSaglasnosti();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [anketaResponse, pitanjaResponse] = await Promise.all([
          AnketaService.getById(id),
          PitanjeService.getByAnketaId(id),
        ]);
        const response = await SaglasnostService.getAll();

        setSaglasnosti(response.data);
        setPitanja(pitanjaResponse.data);
        setNaziv(anketaResponse.data.naziv);
        setOpis(anketaResponse.data.opis);
        setStatus(anketaResponse.data.statusAnkete);
        //  setDatumVazenja(dayjs(anketaResponse.data.datumVazenja));
        setDatumVazenja(
          anketaResponse.data.datumVazenja
            ? anketaResponse.data.datumVazenja
            : null
        );
        setDatumKreiranja(anketaResponse.data.datumKreiranja);
        setKorisnikKorisnickoIme(username);
        setSaglasnost(anketaResponse.data.saglasnostId);
        setTip(anketaResponse.data.tip);
        setToken(anketaResponse.data.token);
        setCounter(pitanjaResponse.data.length);
      } catch (error) {
            if (error.response && error.response.status === 404) {
          setNotFound(true);
        } else {
          console.error("Greška pri učitavanju ankete:", error);
        }
      }
    };

    fetchData();
  }, [id]);

  const handleAddPitanje = (novoPitanje) => {
    const pitanjeSaOdgovorima = {
      ...novoPitanje,
      ponudjeniOdgovori: novoPitanje.ponudjeniOdgovori.map(
        (odgovor, index) => ({
          id: null,
          tekstOdgovora: odgovor.tekstOdgovora,
          pozicija: index + 1,
        })
      ),
    };

    setCounter((prevCounter) => prevCounter + 1);
    setPitanja([...pitanja, pitanjeSaOdgovorima]);
  };

  const handleUpdatePitanje = (uredjenoPitanje) => {
    const pitanjeSaOdgovorima = {
      ...uredjenoPitanje,
      ponudjeniOdgovori: uredjenoPitanje.ponudjeniOdgovori.map(
        (odgovor, index) =>
          typeof odgovor === "string"
            ? { id: null, tekstOdgovora: odgovor, pozicija: index + 1 }
            : { ...odgovor, pozicija: index + 1 }
      ),
    };
    setPitanja((prevPitanja) =>
      prevPitanja.map((pitanje) =>
        pitanje.id === pitanjeSaOdgovorima.id ? pitanjeSaOdgovorima : pitanje
      )
    );
    setEditPitanjaIds((prevState) =>
      prevState.filter((id) => id !== uredjenoPitanje.id)
    );
  };

  const handleDeletePitanje = (index) => {
    setPitanja(pitanja.filter((_, i) => i !== index));
  };

  const handleUpdateAnketa = async () => {
    const updatedAnketa = {
      naziv,
      opis,
      statusAnkete,
      token,
      datumKreiranja,
      datumVazenja,
      tip,
      korisnikKorisnickoIme,
      saglasnostId: saglasnost,
    };

    if (!naziv) {
      return;
    }

    try {
      const response = await AnketaService.updateAnketa(id, updatedAnketa);
     const plainToken = await AnketaService.getTokenByAnketa(id);
     setToken(plainToken);

      const existingPitanjaResponse = await PitanjeService.getByAnketaId(id);
      const existingPitanja = existingPitanjaResponse.data;

      for (const pitanje of pitanja) {
        let pitanjeId = pitanje.id;

        if (pitanjeId) {
          await PitanjeService.updatePitanje(pitanjeId, {
            tekstPitanja: pitanje.tekstPitanja,
            objasnjenje: pitanje.objasnjenje,
            tip: pitanje.tip,
            obavezno: pitanje.obavezno,
            pozicija: pitanje.pozicija,
            anketaId: id,
          });
        } else {
          const response = await PitanjeService.addPitanje({
            tekstPitanja: pitanje.tekstPitanja,
            objasnjenje: pitanje.objasnjenje,
            tip: pitanje.tip,
            obavezno: pitanje.obavezno,
            pozicija: pitanje.pozicija,
            anketaId: id,
          });
          pitanjeId = response.data.id;
          pitanje.id = pitanjeId;
        }

        const existingOdgovori = (
          await PonudjeniOdgovorService.getByPitanjeId(pitanjeId)
        ).data;

        const normalizovaniOdgovori = pitanje.ponudjeniOdgovori.map(
          (odgovor, index) =>
            typeof odgovor === "string"
              ? {
                  id: null,
                  tekstOdgovora: odgovor,
                  pozicija: index + 1,
                  pitanjeId,
                }
              : { ...odgovor, pozicija: index + 1, pitanjeId }
        );
        for (const odgovor of normalizovaniOdgovori) {
          if (odgovor.id) {
            await PonudjeniOdgovorService.updatePonudjeniOdgovor(odgovor.id, {
              tekstOdgovora: odgovor.tekstOdgovora,
              pozicija: odgovor.pozicija,
              pitanjeId: pitanjeId,
            });
          } else {
            const response = await PonudjeniOdgovorService.addPonudjeniOdgovor({
              tekstOdgovora: odgovor.tekstOdgovora,
              pozicija: odgovor.pozicija,
              pitanjeId: pitanjeId,
            });
            odgovor.id = response.data.id;
          }
        }
        for (const existingOdgovor of existingOdgovori) {
          if (!normalizovaniOdgovori.some((o) => o.id === existingOdgovor.id)) {
            await PonudjeniOdgovorService.deletePonudjeniOdgovor(
              existingOdgovor.id
            );
          }
        }
      }

      for (const existingPitanje of existingPitanja) {
        if (!pitanja.some((p) => p.id === existingPitanje.id)) {
          await PitanjeService.deletePitanje(existingPitanje.id);
        }
      }

      navigate(`/zaposleni/anketa/${id}`);
    } catch (error) {
     if (error.response) {
   
  } else if (error.request) {
    console.error("No response received.");
  } else {
    console.error("Error setting up request.");
  }
  console.error("Error.");
    }
  };

  const handleModalOk = () => {
    setModalVisible(false);
    handleUpdateAnketa();
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleDateChange = (date) => {
    setNewDatumVazenja(date);
    setDateConfirmVisible(true);
  };

  const confirmDateChange = () => {
    setDatumVazenja(newDatumVazenja);
    setDateConfirmVisible(false);
  };

  const cancelDateChange = () => {
    setDateConfirmVisible(false);
  };

  const azurirajPozicije = (novaPitanja) => {
    return novaPitanja.map((pitanje, index) => ({
      ...pitanje,
      pozicija: index + 1,
    }));
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const novaPitanja = [...pitanja];
    [novaPitanja[index - 1], novaPitanja[index]] = [
      novaPitanja[index],
      novaPitanja[index - 1],
    ];

    setPitanja(azurirajPozicije(novaPitanja));
  };

  const handleMoveDown = (index) => {
    if (index === pitanja.length - 1) return;
    const novaPitanja = [...pitanja];
    [novaPitanja[index], novaPitanja[index + 1]] = [
      novaPitanja[index + 1],
      novaPitanja[index],
    ];

    setPitanja(azurirajPozicije(novaPitanja));
  };
     if (notFound) return <NotFound />;
  return (
    <div>
      <Background />
      <div className="container add-new-anketa-container">
        <div className="add-new-anketa-card">
          <h1 className="add-new-anketa-title">Uređivanje ankete</h1>
          <Form
            layout="horizontal"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            className="poll-form"
          >
            <Form.Item label="Naziv" required>
              <Input
                className="input-field add-new-anketa-input"
                value={naziv}
                onChange={(e) => setNaziv(e.target.value)}
                placeholder="Unesite naziv ankete"
              />
            </Form.Item>

            <Form.Item label="Opis">
              <TextArea
                className="textarea-field add-new-anketa-input"
                value={opis}
                onChange={(e) => setOpis(e.target.value)}
                placeholder="Unesite opis ankete"
              />
            </Form.Item>

            <Form.Item label="Datum važenja">
              <DatePicker
                className="input-field add-new-anketa-input"
                value={datumVazenja ? dayjs(datumVazenja) : null}
                /* onChange={(date) =>
                  setDatumVazenja(date ? date.toISOString() : null)
                } */
                onChange={(date) =>
                  setDatumVazenja(
                    date ? date.format("YYYY-MM-DDTHH:mm:ss") : null
                  )
                }
                showTime
                placeholder="Izaberite datum"
              />
            </Form.Item>

            <Form.Item label="Saglasnost">
              <Select
                value={saglasnost}
                onChange={setSaglasnost}
                className="select-field add-new-anketa-select"
              >
                {saglasnosti.map((saglasnost) => (
                  <Select.Option key={saglasnost.id} value={saglasnost.id}>
                    {saglasnost.naziv}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Status ankete">
              <Select
                value={statusAnkete}
                onChange={setStatus}
                className="select-field add-new-anketa-select"
              >
                <Select.Option value="AKTIVNA">Aktivna</Select.Option>
                <Select.Option value="NEAKTIVNA">Neaktivna</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="Tip ankete">
              <Select
                value={tip}
                onChange={async (value) => {
                  setTip(value);

         
                }}
                className="select-field add-new-anketa-select"
              >
                <Select.Option value="JAVNA">Javna</Select.Option>
                <Select.Option value="ZASTICENA">Zaštićena</Select.Option>
              </Select>
            </Form.Item>
          </Form>

          <h2 className="title">Pitanja</h2>
          {pitanja.map((pitanje, index) => (
            <div key={index} className="question-item">
              {editPitanjaIds.includes(pitanje.id) ? (
                pitanje.id ? (
                  <UpdatePitanje
                    onSubmit={handleUpdatePitanje}
                    id={pitanje.id}
                  />
                ) : (
                  <EditPitanjeBeforeSave
                    pitanje={pitanje}
                    onSubmit={handleUpdatePitanje}
                  />
                )
              ) : (
                <>
                  <div
                    style={{
                      marginLeft: "20px",
                      marginRight: "30px",
                      marginTop: "20px",
                      paddingTop: "10px",
                    }}
                  >
                    <h4 className="tekst-pitanja">
                      <span className="obavezno-zvezdica">
                        {pitanje.obavezno ? "*" : "\u00A0"}
                      </span>
                      <span className="tekst-broj">{pitanje.pozicija}.</span>
                      <span className="tekst-tekst">
                        {pitanje.tekstPitanja} (
                        {{
                          TEKSTUALNO: "Tekstualno",
                          DA_NE: "Da/ne",
                          JEDAN_IZBOR: "Jedan izbor",
                          VISESTRUKI_IZBOR: "Višestruki izbor",
                        }[pitanje.tip] || pitanje.tip}
                        )
                      </span>
                    </h4>

                    {pitanje.objasnjenje && (
                      <h5 className="pitanje-objasnjenje">
                        {pitanje.objasnjenje}
                      </h5>
                    )}
                    {pitanje.ponudjeniOdgovori.length > 0 && (
                      <ul className="answer-list">
                        {pitanje.ponudjeniOdgovori.map((odgovor, i) => (
                          <li key={i}>{odgovor.tekstOdgovora}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </>
              )}
              <div className="button-container">
                <button
                  onClick={() => handleMoveUp(index)}
                  className="move-btn move-up"
                >
                  ↑
                </button>
                <button
                  onClick={() => handleMoveDown(index)}
                  className="move-btn move-down"
                >
                  ↓
                </button>
                <button
                  onClick={() => handleEditClick(pitanje.id)}
                  className="edit-button"
                >
                  {editPitanjaIds.includes(pitanje.id) ? "Cancel Edit" : "Edit"}
                </button>
                <button
                  className="delete-button"
                  onClick={() =>
                    setConfirmIndex(confirmIndex === index ? null : index)
                  }
                >
                  ✖
                </button>

                {confirmIndex === index && (
                  <div className="confirm-popup">
                    <p className="confirm-text">Obrisati pitanje?</p>
                    <div className="confirm-buttons">
                      <button
                        className="confirm-btn confirm-yes"
                        onClick={() => {
                          handleDeletePitanje(index);
                          setConfirmIndex(null);
                        }}
                      >
                        Da
                      </button>
                      <button
                        className="confirm-btn confirm-no"
                        onClick={() => setConfirmIndex(null)}
                      >
                        Ne
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
          <AddNewPitanje onSubmit={handleAddPitanje} counter={counter} />
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              type="primary"
              size="large"
              onClick={() => setModalVisible(true)}
              className="button-primary"
            >
              Sačuvaj anketu
            </Button>
          </div>
        </div>
        <Modal
          className="custom-anketa-modal"
          title="Da li želite da uredite anketu?"
          visible={modalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          okText="OK"
          cancelText="Otkaži"
          centered
          width="80%"
          maxWidth="80%"
          bodyStyle={{ padding: "30px", overflowY: "auto" }}
        >
          <div className="modal-card">
            <h2 className="modal-title">{naziv}</h2>
            <h4 className="modal-subtitle">{opis}</h4>
            <p>
              <strong>Tip ankete:</strong> {tip}
            </p>
            <p>
              <strong>Status:</strong> {statusAnkete}
            </p>
            <p>
              <strong>Datum važenja:</strong>{" "}
              {datumVazenja
                ? dayjs(datumVazenja).format("YYYY-MM-DD HH:mm")
                : "Nema datuma"}
            </p>
            <h3 className="modal-question-title">Pitanja:</h3>
            <div className="modal-question-list">
              {pitanja
                .sort((a, b) => a.pozicija - b.pozicija)
                .map((p) => (
                  <Pitanje key={p.id} pitanje={p} />
                ))}
            </div>
          </div>
        </Modal>
        <Modal
          open={dateConfirmVisible}
          title="Potvrda"
          onOk={confirmDateChange}
          onCancel={cancelDateChange}
          okText="OK"
          cancelText="Otkaži"
        >
          <p>
            Da li ste sigurni da želite da datum važenja postavite na "
            {newDatumVazenja
              ? dayjs(newDatumVazenja).format("YYYY-MM-DD HH:mm")
              : "Nema datuma"}
            "?
          </p>
        </Modal>
      </div>
    </div>
  );
};

export default EditAnketaPage;
